import { Chat, getChatById, useChatStore } from "@/entities/chat";
import { useAuthStore } from "@/features/auth";

export const getUserNameForChat = async (chatId: string, ownerId?: string) => {
  if (!chatId) return "User"
  
  const currentUser = useAuthStore.getState().user;

  if (chatId === currentUser?._id || ownerId === currentUser?._id) {
    return currentUser?.firstName || "User";
  }

  const chat = await getChat(chatId)

  if (chat) {
    return chat.contact.firstName
  }

  return "User"
}

const getChat = async (chatId: string) => {
  const state = useChatStore.getState();

  const chatFromStore = state.chats.find((chat: Chat) => chat._id === chatId)

  if (chatFromStore) {
    return chatFromStore
  }

  const res = await getChatById(chatId)

  if (res.success) {
    return res.result
  }

  return null
};